import React from 'react';
import './Sidebar.css';

const Sidebar = ({ children, toggled = true, className = '', textColor = '#fff', backgroundColor = '#333' }) => {
    return (
        <div 
            className={`sidebar ${className} ${toggled ? 'sidebar-toggled' : ''}`}
            style={{ 
                color: textColor, 
                backgroundColor: backgroundColor 
            }}
        >
            {children}
        </div>
    );
};

export default Sidebar;
